/**
 * @generated SignedSource<<d70ac714411ab907a4b1747dcc74df13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type requestCareDetailInsertMutation$variables = {
  addressdetail: string;
  desiredenddate: any;
  desiredstartdate: any;
  hospitalid: number;
  insuranceid: string;
  otherrequirement: string;
  patientname: string;
  recipientid?: string | null | undefined;
  requeststatus: number;
  requesttype: number;
};
export type requestCareDetailInsertMutation$data = {
  readonly insert_insurance_request_log_one: {
    readonly id: string;
    readonly request_care_details: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type requestCareDetailInsertMutation = {
  response: requestCareDetailInsertMutation$data;
  variables: requestCareDetailInsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addressdetail"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "desiredenddate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "desiredstartdate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hospitalid"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "insuranceid"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherrequirement"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientname"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recipientid"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requeststatus"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requesttype"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "insuranceid",
            "variableName": "insuranceid"
          },
          {
            "kind": "Variable",
            "name": "recipientid",
            "variableName": "recipientid"
          },
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "addressdetail",
                    "variableName": "addressdetail"
                  },
                  {
                    "kind": "Variable",
                    "name": "desiredenddate",
                    "variableName": "desiredenddate"
                  },
                  {
                    "kind": "Variable",
                    "name": "desiredstartdate",
                    "variableName": "desiredstartdate"
                  },
                  {
                    "kind": "Variable",
                    "name": "hospitalid",
                    "variableName": "hospitalid"
                  },
                  {
                    "kind": "Variable",
                    "name": "otherrequirement",
                    "variableName": "otherrequirement"
                  },
                  {
                    "kind": "Variable",
                    "name": "patientname",
                    "variableName": "patientname"
                  }
                ],
                "kind": "ObjectValue",
                "name": "data"
              }
            ],
            "kind": "ObjectValue",
            "name": "request_care_details"
          },
          {
            "kind": "Variable",
            "name": "requeststatus",
            "variableName": "requeststatus"
          },
          {
            "kind": "Variable",
            "name": "requesttype",
            "variableName": "requesttype"
          }
        ],
        "kind": "ObjectValue",
        "name": "object"
      }
    ],
    "concreteType": "insurance_request_log",
    "kind": "LinkedField",
    "name": "insert_insurance_request_log_one",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "request_care_detail",
        "kind": "LinkedField",
        "name": "request_care_details",
        "plural": false,
        "selections": [
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "requestCareDetailInsertMutation",
    "selections": (v11/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "requestCareDetailInsertMutation",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "82f000d48d9e718cc2bf55c526f30bfa",
    "id": null,
    "metadata": {},
    "name": "requestCareDetailInsertMutation",
    "operationKind": "mutation",
    "text": "mutation requestCareDetailInsertMutation(\n  $insuranceid: String!\n  $requesttype: Int!\n  $requeststatus: Int!\n  $recipientid: String\n  $hospitalid: Int!\n  $patientname: String!\n  $otherrequirement: String!\n  $desiredstartdate: timestamptz!\n  $desiredenddate: timestamptz!\n  $addressdetail: String!\n) {\n  insert_insurance_request_log_one(object: {insuranceid: $insuranceid, requesttype: $requesttype, requeststatus: $requeststatus, recipientid: $recipientid, request_care_details: {data: {hospitalid: $hospitalid, patientname: $patientname, otherrequirement: $otherrequirement, desiredstartdate: $desiredstartdate, desiredenddate: $desiredenddate, addressdetail: $addressdetail}}}) {\n    id\n    request_care_details {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e2be7e3bd6253993997f813aa50b446c";

export default node;
